module.exports = __webpack_public_path__ + "static/media/29COICT2.dc4a400a.jpg";